import NavLinks from "@/components/navBar/NavLinks"
import EightFourThreeLogo from "@/common/images/843_Logo_Blue.png"
import { FilterMenuButton } from "./FilterMenuButton"
import { AppBar, Stack, Toolbar, Box } from "@mui/material"
import { UserButton } from "../users/UserIcon"
import MapFilterNavigation from "../mapFilter/MapFilter"
import SearchBar from "./SearchBar"
import { useEventContext } from "@/contexts/EventContext"
import useIsTablet from "@/hooks/useIsTablet"
import { useNavBarContext } from "@/contexts/NavBarContext"

const MobileNavBar = () => {
  const { searchActive } = useEventContext()
  const isTablet = useIsTablet()
  const { setIsHovered } = useNavBarContext()
  return (
    <AppBar
      onMouseEnter={() => {
        if (isTablet) {
          setIsHovered(true)
        }
      }}
      onMouseLeave={() => {
        if (isTablet) {
          setIsHovered(false)
        }
      }}
      position="sticky"
      style={{
        backgroundColor: "white",
        justifyContent: "center",
      }}
    >
      <Toolbar
        disableGutters={true}
        sx={{
          width: "100%",
          position: "relative",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          width="100%"
          sx={{
            paddingLeft: isTablet ? "1rem" : "0.5rem",
            paddingRight: isTablet ? "1rem" : "0.5rem",
            alignItems: "center",
          }}
        >
          <a
            href="/about-us"
            style={{
              display: "flex",
              alignItems: "center",
              width: "50px",
              height: "50px", // or a fixed width if needed
            }}
          >
            <img
              src={EightFourThreeLogo}
              alt="843hub Logo"
              style={{
                width: isTablet ? "70px" : "40px", // Set a specific width
                height: isTablet ? "50px" : "30px", // Set a specific height
                // transform: "scale(1.2, 1.2)",
              }}
            />
          </a>

          {isTablet ? (
            <Box
              sx={{
                position: "absolute",
                left: "35%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                alignItems: "center",
                gap: 1.5, // keeps consistent spacing between icon and links
              }}
            >
              <SearchBar />
            </Box>
          ) : (
            <SearchBar />
          )}
          {searchActive ? <></> : <NavLinks />}
          <Stack gap={1} direction="row">
            {!isTablet && <FilterMenuButton />}
            <UserButton />
          </Stack>
        </Stack>
      </Toolbar>
      {isTablet ? (
        <MapFilterNavigation />
      ) : (
        <Box
          display={"flex"}
          flexDirection={"row"}
          sx={{ width: "100%", overflowY: "hidden", overflowX: "auto" }}
        >
          {!["/profile", "/about-us"].includes(location.pathname) && (
            <MapFilterNavigation />
          )}
        </Box>
      )}
    </AppBar>
  )
}

export default MobileNavBar
